import React from "react";
import FormContact from "../components/common/FormContact";

const ContactPage = () => {
  return (
    <>
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: "500px" }}
          >
            <h2 className="display-5 mb-5" style={{ minWidth: "500px" }}>
              Nhập thông tin của bạn để chúng tôi có thể liên hệ
            </h2>
          </div>
          <div className="row g-5">
            <FormContact />
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <h3 className="mb-4">Chi tiết liên hệ</h3>
              <div className="d-flex border-bottom pb-3 mb-3">
                <div className="flex-shrink-0 btn-square bg-primary rounded-circle">
                  <i className="fa fa-map-marker-alt text-white"></i>
                </div>
                <div className="ms-3">
                  <h6>Văn Phòng</h6>
                  <span>
                    <a
                      href="https://maps.app.goo.gl/pqdaMuLwYWjFVZHu5"
                      target="_blank"
                      className="text-black no-underline-link"
                    >
                      271 Nguyễn Văn Linh, Thanh Khê, Đà Nẵng
                    </a>
                  </span>
                </div>
              </div>
              <div className="d-flex border-bottom pb-3 mb-3">
                <div className="flex-shrink-0 btn-square bg-primary rounded-circle">
                  <i className="fa fa-phone-alt text-white"></i>
                </div>
                <div className="ms-3">
                  <h6>Liên hệ </h6>
                  <span>
                    <a
                      href="tel::0838598518"
                      className="text-black no-underline-link"
                    >
                      +0838598518
                    </a>
                  </span>
                </div>
              </div>
              <iframe
                className="w-100 rounded"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3834.1125698262404!2d108.20909157459984!3d16.059647239695405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x314219b5d0edf95f%3A0x6fe96f80eb26d8c3!2zMjcxIMSQLiBOZ3V54buFbiBWxINuIExpbmgsIFbEqW5oIFRydW5nLCBUaGFuaCBLaMOqLCDEkMOgIE7hurVuZyA1NTAwMDAsIFZp4buHdCBOYW0!5e0!3m2!1svi!2s!4v1742117710009!5m2!1svi!2s"
                frameborder="0"
                style={{ minHeight: "300px ", border: 0 }}
                allowfullscreen=""
                aria-hidden="false"
                tabIndex="0"
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
